/**
 * @generated SignedSource<<2dcecc4cf77c28971c0e027dab15874b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resellerPlId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "revenuePeriod",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "revenueMin",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "incentivePerc",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResellerProgramLineCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateResellerProgramLineTPayload",
        "kind": "LinkedField",
        "name": "createResellerProgramLineT",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ResellerProgramLineT",
            "kind": "LinkedField",
            "name": "resellerProgramLineT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResellerProgramLineCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateResellerProgramLineTPayload",
        "kind": "LinkedField",
        "name": "createResellerProgramLineT",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ResellerProgramLineT",
            "kind": "LinkedField",
            "name": "resellerProgramLineT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "672ccceb27d6fc8d7c7e23f1d859036e",
    "id": null,
    "metadata": {},
    "name": "ResellerProgramLineCreateMutation",
    "operationKind": "mutation",
    "text": "mutation ResellerProgramLineCreateMutation(\n  $input: CreateResellerProgramLineTInput!\n) {\n  createResellerProgramLineT(input: $input) {\n    resellerProgramLineT {\n      resellerPlId\n      revenuePeriod\n      revenueMin\n      incentivePerc\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "59af471aa9d9e645e0d58acc340edd80";

module.exports = node;
